import { FormFieldType } from 'types';

/** Content-only fields have no answer, validation, question number or progress. */
export const isStaticFormField = (type: FormFieldType): boolean =>
  type === FormFieldType.HEADING || type === FormFieldType.TEXT;
